import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'fl-carousel-item',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['./carousel-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselItemComponent {
  elementRef = inject(ElementRef);
}
